import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { Router } from '@angular/router';
import { PopupService } from '@app/shared/services/popup/popup.service';
import { ForgotPasswordComponent } from '../../core/components/forgot-password/forgot-password.component';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  constructor(public dialog: MatDialog,
    private loaderService: LoaderService,
    private router: Router,
    private renderer: Renderer2,
    private popupService: PopupService,
    private localstorageService: LocalStorageService) {
  }
  clearLogin = false;
  showVideo = false;

  ngOnInit() {

    this.loaderService.show();

    if (this.router.url === '/') {
      this.localstorageService.remove('storeId');
    }
    //This is coming from app.merchloop for password recovery
    if (location.pathname.split("/")[1] == "RecoverPassword") {
      // Add class to body
      this.renderer.addClass(document.body, 'dialog-dark-backdrop');
      localStorage.clear();

      this.dialog.open(ForgotPasswordComponent, {
        width: '800px',
        height: '500px',
        disableClose: true,
      });


    }
    if (localStorage.getItem('role') === 'StoreAdmin' || localStorage.getItem('role') === 'StoreOwner' || localStorage.getItem('role') === 'StoreStaffMember') {
      this.loaderService.show();
      this.router.navigate(['/store/dashboard']);
    }
    if (localStorage.getItem('role') === 'SuperAdmin' || localStorage.getItem('role') === 'CustomerService') {
      this.loaderService.show();
      this.router.navigate(['/superadmin/dashboard']);
    }

    setTimeout(() => {
      this.loaderService.hide();
    }, 3000);
  }

  opensignupformDialog(): void {
    this.popupService.openSignUp();
  }

  openloginFormDialog(): void {
    this.popupService.openLogin();
  }


}

